import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { ProjectCategoryDto, ProjectTypeDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-project-type-view',
  templateUrl: './project-type-view.component.html',
  styleUrls: ['./project-type-view.component.css'],
})
export class ProjectTypeViewComponent implements OnInit {
  @Input() projectCategories: ProjectCategoryDto[];
  @Input() projectTypes: ProjectTypeDto[];
  projectTypeForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<ProjectTypeDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  selectedProjectCategory: any;
  filteredDelete: Array<any> = [];
  loading = true;
  filteredProjectType: Array<any> = [];
  status: boolean;
  selectedProjectCategoryId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.projectTypeForm = this.fb.group({ ProjectTypes: this.fb.array([]) });
  }

  // method to display countries
  setProjectType() {
    const control = this.projectTypeForm.controls.ProjectTypes as FormArray;
    this.filteredProjectType.forEach((e) => {
      control.push(
        this.fb.group({
          ProjectTypeName: e.ProjectTypeName,
          ProjectCategoryId: e.ProjectCategoryId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.projectTypeForm.controls.ProjectTypes as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter state
  selectProjectType(event: string) {
    this.filteredProjectType = this.projectTypes.filter(
      (s) => s.ProjectCategoryId === event
    );
    this.selectedProjectCategoryId = event;
    const control = this.projectTypeForm.controls.ProjectTypes as FormArray;

    if (this.filteredProjectType.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setProjectType();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Country
  addProjectType() {
    const control = this.projectTypeForm.controls.ProjectTypes as FormArray;
    control.insert(
      0,
      this.fb.group({
        ProjectTypeName: ['', Validators.required],
        ProjectCategoryId: this.selectedProjectCategoryId,
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteProjectType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.projectTypeForm.controls.ProjectTypes as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.projectTypes.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.projectTypes[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'projectType';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('projectType');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
